export default __webpack_public_path__ + "static/media/dragon1.7ccb3981.jpg";